import { PatientWithAccessRightDTO } from '@peartherapeutics/weaver-api-client';
import { actionTypes } from 'actions/patientDetailsList';

const initialState: PatientWithAccessRightDTO[] = [];

export default (
  state: PatientWithAccessRightDTO[] = initialState,
  action: Action<any>,
): PatientWithAccessRightDTO[] => {
  switch (action.type) {
    case actionTypes.GET_PATIENT_DETAILS_LIST_SUCCESS: {
      return action.payload;
    }
    case actionTypes.GET_PATIENT_DETAILS_LIST_ERROR: {
      return [];
    }
    default: {
      return state;
    }
  }
};
